import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { serverResponse } from "./validators";

interface IFetchPromoCodesProps {
  userId: string;
}

export async function fetchPromoCodes({ userId }: IFetchPromoCodesProps) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/vouchers/digitals?category=postActivationCode&userId=${userId}`,
    {
      method: "get",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
